export default "__VITE_ASSET__C3Oqdmf6__"